var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GetStartedInstructions',{class:_vm.$style.collapsableSection,attrs:{"localStorageKey":_vm.localStorageKey,"primaryLink":"https://support.jumpcloud.com/support/s/article/getting-started-groups","startCollapsed":_vm.collapsed,"title":""}},[_c('GroupsGetStartedInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }